/**
 * 与 AnimockServer `config/buildadmin.php` 中 `default_avatar` 一致。
 */
export const DEFAULT_USER_AVATAR_PATH = '/static/images/avatar.png'

function hasResolvableAbsoluteUrlPrefix(s: string): boolean {
  if (/^https?:\/\//i.test(s)) return true
  if (s.startsWith('//')) return true
  if (/^data:/i.test(s)) return true
  if (/^blob:/i.test(s)) return true
  return false
}

/**
 * 解析用户头像 URL：空值回退默认头像；相对路径拼接 `ANIMOCK_STATIC_URL`（或 API 根）。
 *
 * @param avatar - 会话或接口中的头像字段
 * @param staticBase - 静态资源根（如 `http://127.0.0.1:8000`），末尾勿带 `/`
 */
export function resolveUserAvatarUrl(
  avatar: string | null | undefined,
  staticBase: string,
): string {
  const raw = typeof avatar === 'string' ? avatar.trim() : ''
  const path = raw || DEFAULT_USER_AVATAR_PATH
  if (hasResolvableAbsoluteUrlPrefix(path)) return path
  const base = staticBase.trim().replace(/\/+$/, '')
  if (!base) return path
  const rel = path.startsWith('/') ? path : `/${path}`
  return `${base}${rel}`
}
